/**
 * In-app navigation uses BARE paths (e.g. "/app/chat"). The active user/location
 * context is carried by the localforage session, not the URL — so the app no
 * longer re-prepends `btoa("<email>:<locationId>")` to links it generates for
 * its own navigation (which made every URL long and exposed the email).
 *
 * The encoded prefix is still an INBOUND deep-link / SSO-embed credential: it's
 * read by `context/user.js` (passwordless auto-login) when a fresh session lands
 * on `/<blob>/app/...`, and still produced by `pages/SSOIframe` for cross-product
 * iframes. Option A only stops the *internal* re-prepending. Fully removing the
 * email from the inbound link is a separate backend/cross-system change.
 * See docs/superpowers/specs/2026-06-24-email-in-url-cleanup-design.md.
 *
 * Kept as a function with the same signature so callers (AppNav, AppShell) are
 * unchanged and the behaviour is reversible in one place. The auth-context
 * options are intentionally ignored.
 */
export function buildAuthedPath(path) {
  return path;
}
